import { render } from "./ShippingAddressView.vue?vue&type=template&id=b6e521f6&scoped=true"
import script from "./ShippingAddressView.vue?vue&type=script&lang=js"
export * from "./ShippingAddressView.vue?vue&type=script&lang=js"

import "./ShippingAddressView.vue?vue&type=style&index=0&id=b6e521f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6e521f6"]])

export default __exports__